const PROD_STUDIO_ORIGIN = 'https://studio.ouster.com';
const STAGING_STUDIO_ORIGIN = 'https://studio.staging.ouster.com';

function getThumbnailBaseOrigin() {
  const currentOrigin =
    typeof window === 'undefined' ? '' : window.location.origin;

  return currentOrigin.startsWith(PROD_STUDIO_ORIGIN)
    ? PROD_STUDIO_ORIGIN
    : STAGING_STUDIO_ORIGIN;
}

export function getInAppDemoBackgroundStyle(filename: string) {
  return {
    background: `url('${getThumbnailBaseOrigin()}/thumbnails/${filename}') no-repeat left top / cover`,
  };
}
